import React, { useMemo } from 'react';
import CircularButton from '../../inputs/CircularButton';
import CaretIcon from '../../icons/utility/CaretIcon';
import useComponentMargin from '../../hooks/useComponentMargin';
import { calcNextOffset, calcPreviousOffset } from './utils';
export const NavButton = ({ handleClick, offset, limit, disabled, direction, isLink, gatsbyLink, href, styles, ...rest }) => {
    const isForward = direction === 'forward';
    const handleForwardClick = useMemo(() => handleClick && handleClick({ offset: calcNextOffset(offset, limit), limit }), [offset, limit, handleClick]);
    const handleBackwardClick = useMemo(() => handleClick && handleClick({ offset: calcPreviousOffset(offset, limit), limit }), [offset, limit, handleClick]);
    const backwardMargin = useComponentMargin({ marginLeft: 'small' });
    const forwardMargin = useComponentMargin({ marginRight: 'small' });
    const mergedStyles = useMemo(() => ({
        ...(isForward ? forwardMargin : backwardMargin),
        ...styles
    }), [styles, isForward, forwardMargin, backwardMargin]);
    return (React.createElement(CircularButton, { onClick: isForward ? handleForwardClick : handleBackwardClick, disabled: disabled, styles: mergedStyles, isLink: isLink, gatsbyLink: gatsbyLink, href: href, ...rest },
        React.createElement(CaretIcon, { size: "small", direction: direction, disabled: disabled, type: "inverted" })));
};
export default NavButton;
//# sourceMappingURL=NavButton.js.map